/* global $:false */

import countdown from 'countdown/countdown'

export default class MarketLotIndexCountdown {
  constructor (parent) {
    this._tick = this._tick.bind(this)
    this.el = $(parent).find('.js-market-lot-index-countdown')
  }

  start (endDate) {
    // endDate is the UNIX timestamp in seconds, countdown expects milliseconds.
    this.countdown = countdown(endDate * 1000, this._tick, countdown.DEFAULTS, 2)
  }

  update (endDate) {
    clearInterval(this.countdown)
    this.start(endDate)
    this.updated = true
  }

  expire () {
    // Make sure the countdown does not come back even when the browser-back-button was pressed.
    this.el.remove()
    clearInterval(this.countdown)
  }

  _tick (countdown) {
    if (this._endedLongAgo(countdown)) { this.expire() }

    if (this._lessThanAMinute(countdown)) {
      this.el.html('< 1m')
      this.el.addClass('c-market-lot-index-countdown--less-than-a-minute')
    } else {
      this.el.html(countdown.toString())
      this.el.removeClass('c-market-lot-index-countdown--less-than-a-minute')
    }
  }

  _endedLongAgo (countdown) {
    return countdown.value > (60 * 1000)
  }

  _lessThanAMinute (countdown) {
    if (countdown.value > 0) { return true } // Countdown has ended

    return (countdown.minutes === 0) &&
      (countdown.hours === 0) &&
      (countdown.days === 0)
  }
}
